/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from "./Alert";
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import Globals from "../shared/Globals";
import { SidebarGlobal } from "./_SidebarGlobal";
import Paging from "./Paging";
import Auth from "../shared/Auth";
import FormInput from "./FormInput";
import { Modal } from "react-bootstrap";
import Icon from "./Icon";
import { Pop } from "./PopModal";
import L from "./Lang";

class Invoices extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {
                page: props.params.page ?? 1,
                qfilters: {},
                search: null
            },
            filters: {},
            loaded: false,
            loading: false,
            list: [],
            req: {}
        };
    }

    async componentDidMount() {
        this.setState({ user: await Auth.getLoginAsync() });
        this.load();
        SidebarGlobal.setSubNav(<><div className="btn-group">
            <Link to="/invoice/new" className="btn btn-primary"><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline"><L>New Invoice</L></span></Link>
        </div></>);
        this.checkPaymentEnabled();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.params.page !== this.props.params.page) {
            this.setState({ query: { ...this.state.query, page: this.props.params.page || 1 } });
        }
        if (prevState.query !== this.state.query) {
            if (this.state.query)
                this.load();
        }
    }

    dateFilter(filters, varNames, val) {
        var n = 0;
        if (val) {
            varNames.forEach(i => {
                filters[i] = val[n];
                n++;
            });
        }
        else {
            varNames.forEach(i => {
                delete filters[i];
            });
        }
    }

    onFilter = (col) => {
        var filters = { ...this.state.filters };

        if (col.filter.filter === 'invoicedate') this.dateFilter(filters, ['InvoideStartDate', 'InvoiceEndDate'], col.filter.value);
        else {
            if (col.filter.value)
                filters[col.filter.filter] = col.filter.value;
            else
                delete filters[col.filter.filter];
        }
        var query = { ...this.state.query, qfilters: filters };
        this.setState({ filters: filters, query: query });
    }

    load = (query) => {
        if (!query)
            query = this.state.query;
        this.setState({ loading: true });
        qreq.post('/api/invoice/list', query, j => {
            if (j.list) {
                this.setState({ list: j.list, pageCount: j.pageCount, totalCount: j.totalCount });
            }
            else if (j.errorCode !== 0) {
                this.setState({ errorMessage: j.errorMessage });
            }
            this.setState({ loaded: true, loading: false });
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
        });
    }

    checkPaymentEnabled = async () => {
        try {
            const j = await qreq.getAsync('/api/payment/enabled');
            if (j.errorCode) {
                this.setState({ paymentEnabledError: j.errorMessage });
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    search = (v) => {
        let query = { ...this.state.query, search: v };
        this.setState({ query: query });
    }

    sendPaymentRequest = async (e) => {
        e?.preventDefault();
        this.setState({ submitting: true });
        try {
            let j = await qreq.postAsync('/api/payment/request/send', this.state.req);
            if (j.item) {
                this.setState({ showSendPaymentRequest: false });
                this.success('Email sent!');
            }
            else {
                this.alert(j.errorMessage);
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    delete = (obj) => {
        if (Pop.showConfirm(<L>Are you sure you want to delete this invoice?</L>, <L>Delete Invoice</L>, () => {
            qreq.post('/api/invoice/delete', { id: obj.id }, () => { this.load(); });
        }));
    }


    render() {
        const header = (<h1><L>Invoice</L></h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        const columns = [
            {
                name: 'Pencil', link: '/invoice/edit/:id', valueFunc: row => {
                    if (Auth.hasPolicy('admin') || row.fromAccountID === this.state.user?.primaryAccountID)
                        return <Link to={'/invoice/edit/' + row.id}><Icon icon="faPencil" /></Link>;
                    return;
                }, style: { width: '50px' }
            },
            { icon: 'FilePdf', tooltip: 'Download Invoice', onClick: obj => { window.open(Globals.serverUrl + '/api/invoice/pdf/' + obj.iid); } },
            {
                name: 'PaperPlane', tooltip: 'Send Payment Request', valueFunc: row => {
                    if (Auth.hasPolicy('admin')) {
                        return <Icon icon="faPaperPlane" onClick={() => this.setState({
                            showSendPaymentRequest: true, req:
                            {
                                invoiceID: row.id
                            },
                            selectedInvoice: row
                        })} role="button" className="text-primary" />
                    }
                    return;
                }, style: { width: '50px' }
            },
            { name: 'iid', title: 'ID', className: 'd-none d-md-table-cell' },
            { name: 'accountName', title: 'Account', className: 'd-none d-md-table-cell' },
            { name: 'invoiceDate', title: 'Invoice Date', format: 'date', className: 'd-none d-md-table-cell' },
            { name: 'dueDate', title: 'Due Date', format: 'date' },
            {
                name: 'status', title: 'Status', valueFunc: i => {
                    if (i.isPaid || i.balanceDue === 0)
                        return <span className="text-success"><L>Paid</L></span>;
                    return <span className="text-secondary"><L>Pending</L></span>;
                }
            }
        ];

        if (this.state.MODEL === 'WMS')
            columns.splice(4, 0, { name: 'patientName', title: 'Patient' });

        if (Auth.hasPolicy('admin')) {
            columns.push({
                name: 'createdByUserName',
                title: 'Created By',
                className: 'd-none d-md-table-cell'
            });
        }
        else {
            columns.splice(7, 1);
        }

        if (Auth.hasRole('!')) {
            columns.splice(1, 0, {
                name: 'delete', valueFunc: obj => <Icon icon="faTrash" className="text-danger" role="button" onClick={() => this.delete(obj)} />, width: '25px'
            });
        }

        return <div className="container-fluid">
            {header}
            <div>
                <FormInput
                    model={this.state.query}
                    name="search"
                    type="text"
                    onChange={this.search}
                    label="Search..."
                    labelAsPlaceholder
                />
            </div>
            <DataTable columns={columns} data={this.state.list} loading={this.state.loading} totalCount={this.state.totalCount} showFilters={false} onFilter={this.onFilter} filters={[
                { name: 'invoiceDate', title: 'Invoice Date', filter: 'invoicedate', type: 'daterange' }
            ]} sticky heightDelta="420" />
            <div className="card-body">
                <Paging baseLoc="/invoice/list/page/" pageCount={this.state.pageCount} currentPage={this.state.query?.page} onPageClick={(e) => this.setState({ loading: true })} />
            </div>




            {/* MODAL: PAYMENT REQUEST */}
            {this.state.showSendPaymentRequest && <Modal show={this.state.showSendPaymentRequest} onHide={() => this.setState({ showSendPaymentRequest: false })}>
                <Modal.Header>
                    <Modal.Title><L>Payment Request</L></Modal.Title>
                </Modal.Header>
                <form onSubmit={this.sendPaymentRequest}>
                    <Modal.Body>
                        {this.state.paymentEnabledError && <Alert type="warning">{this.state.paymentEnabledError}</Alert>}
                        <FormInput model={this.state.req} name="name" label="Name" type="text" placeholder="John Doe" required />
                        <FormInput model={this.state.req} name="email" label="Email" type="email" placeholder="example@udhs.net" required />
                        <p className="text-muted"><L>Who are you sending this payment request to?</L></p>
                        <p><i><L>Payment request expires in 7 days if not processed.</L></i></p>
                        <p>The payment request is for amount: <strong>{Globals.formatCurrency(this.state.selectedInvoice?.balanceDue)}</strong></p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" className="btn btn-success btn-lg" disabled={this.state.submitting}><Icon icon="faPaperPlane" /> <L>Send</L></button>
                        <button type="button" className="btn btn-secondary btn-lg" onClick={() => this.setState({ showSendPaymentRequest: false })}>
                            Cancel
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>}




        </div>;
    }
}

export default withParamsAndNavigate(Invoices);